"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.suppressConsoleWarning = exports.suppressConsoleError = void 0;
var suppressConsoleError = function (shouldBeHidden) {
    var _err = console.error;
    console.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof args[0] === "string" && shouldBeHidden(args[0])) {
            return;
        }
        //@ts-ignore
        _err.apply(console, args);
    };
};
exports.suppressConsoleError = suppressConsoleError;
var suppressConsoleWarning = function (shouldBeHidden) {
    var _warn = console.warn;
    console.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof args[0] === "string" && shouldBeHidden(args[0])) {
            return;
        }
        //@ts-ignore
        _warn.apply(console, args);
    };
};
exports.suppressConsoleWarning = suppressConsoleWarning;
